import { create } from "zustand";
import axios from "axios";

// API 기본 설정
const api = axios.create({
	baseURL: import.meta.env.VITE_API_URL || 'http://localhost:8091/api/v1',
});

// 인터셉터 설정 - 모든 요청에 토큰 추가
api.interceptors.request.use(
	(config) => {
		const token = JSON.parse(localStorage.getItem("auth-storage"))?.state
			?.token;
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => Promise.reject(error)
);

export const useHomeStore = create((set, get) => ({

	// 티켓 정보 조회 (period: 'monthly' | 'daily')
	getMonthTicketInfo: async (period = "monthly") => {
		try {
			const response = await api.get("/tickets/summary", {
				params: { period },
			});

			const data = await response.data;

			return { success: true, data: data };
		} catch (err) {
			console.error("Error fetching ticket info:", err);
			const errorMessage =
				err.message || "티켓 정보를 가져오는 중 오류가 발생했습니다.";
			return { success: false, error: errorMessage };
		}
	},
}));